{
  "common": {
    "save": "حفظ",
    "cancel": "إلغاء",
    "welcome": "مرحباً، {{name}}",
    "back": "عودة",
    "send": "إرسال",
    "sending": "إرسال...",
    "backToLogin": "عودة إلى تسجيل الدخول",
    "loginNow": "بتسجيل الدخول الآن"
  },
  "auth": {
    "login": "تسجيل الدخول",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور"
  },
  "errorCard": {
    "title": "عذراً! حدث خطأ ما!",
    "refreshPage": "يرجى تحديث الصفحة",
    "orBack": " أو الضغط على العودة.",
    "orHome": " أو العودة للصفحة الرئيسية.",
    "refreshBtn": "تحديث",
    "backBtn": "العودة"
  },
  "confirmEmail": {
    "verifying": "جاري التحقق من بريدك الإلكتروني...",
    "verified": "تم التحقق من البريد الإلكتروني بنجاح!"
  },
  "createBtn": "مقترح جديد",
  "replyCall": "الرد على الطلب",
  "sidebar": {
    "pitches": "مقترحات",
    "calls": "طلبات المقترحات",
    "commissions": "مقترحات مباعه",
    "faq": "الأسئلة المتكررة",
    "safety": "نصائح السلامة",
    "terms": "الشروط والأحكام",
    "support": "الدعم"
  },
  "support": {
    "general": "استفسار عام",
    "tech": "الدعم التقني",
    "finance": "استفسار عن المدفوعات",
    "supportType": "نوع الدعم",
    "subject": "الموضوع",
    "description": "الرسالة",
    "confirmation": "تم الإرسال بنجاح."
  },
  "navbar": {
    "langSwitch": "تغيير اللغة",
    "lang": "اللغة",
    "logout": "تسجيل الخروج"
  },
  "richEditor": {
    "placeholder": "ابدأ بكتابة مقترحك..."
  },
  "pitch": {
    "discussion": "المناقشة",
    "finalVersion": "النسخة النهائية",
    "commissioningOffer": "عرض البيع",
    "attach": "المرفقات",
    "approveFinal": "اعتماد النسخة النهائية",
    "approvedFinal": "نسخة نهائية معتمدة"
  },
  "pitchGuidelines": {
    "title": "كيف يمكنك كتابة مقترح جيد؟",
    "disclaimer": "تنوية: سيؤدي اتباع هذه الإرشادات إلى زيادة فرصة قبول مقترحك",
    "ol1": "يجب أن يحتوي المقترح على شخصية رئيسية وأن تلخص الفقرة الأولى القصة مع التركيز على أقوى جانب بالقصة.",
    "ol2": "يجب أن يشرح المقترح فيما لا يزيد عن 300 كلمة:",
    "ol3": "في حالة صحافة الحلول (تخصص إيجاب) ، يجب أن يجيب العرض التقديمي على سؤال آخر:",
    "ul1-1": "ما هي القصة؟",
    "ul1-2": "لماذا هذه القصة؟ (لماذا يجب أن يهتم بها الجمهور العالمي؟ ببساطة ما هي أهمية هذه القصة؟)",
    "ul1-3": "لماذا الآن؟ (في بعض الأحيان يكون هناك حدث دولي قادم أو يوم عالمي يمكن ربط توقيت المقترح به. ولكن في معظم الأوقات، يكفي مجرد مرور الوقت الكافي لتقييم مبادرة ما)",
    "ul1-4": "لماذا أنت أفضل شخص لتغطية هذه القصة؟",
    "ul2-1": "كيف يعمل الحل الذي تود تغطيته؟ (ما الجديد أو المختلف في هذا الحل ولماذا نجح أو فشل هذا الحل؟)",
    "pitchExamplesBtn": "تصفح أمثله للمقترحات"
  },
  "forget": {
    "pageTitle": "إعادة تعيين كلمة المرور",
    "title": "أدخل بريدك الإلكتروني للحصول على رابط إعادة التعيين!",
    "successTitle": "تحقق من الرابط الموجود في بريدك الإلكتروني لإكمال عملية إعادة تعيين كلمة المرور."
  },
  "reset": {
    "pageTitle": "إعادة تعيين كلمة المرور",
    "title": "اختر كلمة مرور جديدة",
    "successTitle": "تمت إعادة تعيين كلمة المرور بنجاح!",
    "subtitle": "يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة.",
    "submit": "تعيين",
    "submitting": "جاري التعيين..."
  },
  "status": {
    "all": "الكل",
    "saved": "مسودة",
    "submitted": "تم التسليم",
    "review": "تحت المراجعة",
    "editorComment": "تعليق المحرر",
    "journalistComment": "تعليق الصحفي",
    "approved": "موثق",
    "rejected": "مرفوض",
    "commissioned": "تم البيع",
    "commissioningOffer": "عرض بيع",
    "callPublished": "منشورة",
    "callExpired": "منتهية"
  },
  "pitchCard": {
    "editor": "المحرر"
  },
  "comments": {
    "title": "التعليقات",
    "placeholder": "اكتب تعليق...",
    "closed": "تم إغلاق التعليقات على هذا المقترح!",
    "comment": "أضف تعليق",
    "voice": "رسالة صوتية",
    "stop": "أيقاف",
    "record": "جاري التسجيل"
  },
  "page": {
    "next": "التالي",
    "previous": "السابق",
    "result": "نتيجة"
  },
  "details": {
    "title": "التفاصيل",
    "status": "الحالة",
    "posted": "تاريخ النشر",
    "lang": "اللغة",
    "loc": "الموقع",
    "format": "صيغه المقترح",
    "themes": "الموضوعات",
    "deadline": "تاريخ التسليم",
    "budget": "السعر",
    "editor": "المحرر",
    "journalist": "الصحفي",
    "submit": "تسليم المقترح"
  },
  "create": {
    "pageTitle": "مقترح جديد",
    "title": "العنوان",
    "titlePlaceholder": "عنوان المقترح",
    "content": "المحتوى",
    "attachments": "المرفقات",
    "select": "اختر ",
    "lang": "اللغة",
    "loc": "الموقع",
    "format": "صيغه المقترح",
    "themes": "الموضوعات",
    "submit": "تسليم المقترح",
    "save": "حفظ المقترح",
    "saving": "جاري الحفظ...",
    "submitting": "جاري التسليم...",
    "cancel": "إلغاء",
    "noItem": "لا يوجد نتائج"
  },
  "uploadTitle": "أسقط الملفات هنا أو انقر للتحميل",
  "uploadAccepted": "الملفات المطلوبة",
  "signup": {
    "signup": "اشترك",
    "title": "اشترك في حساب صحفي",
    "haveAccount": "لديك حساب بالفعل؟ ",
    "signin": "تسجيل الدخول",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "repeatPassword": "إعادة كلمة المرور",
    "continue": "متابعة",
    "agreement": "بالنقر على \"متابعة\"، فإنك توافق على ",
    "and": "و",
    "terms": "شروطنا وأحكامنا",
    "privacy": "سياسة الخصوصية",
    "emailRequired": "البريد الإلكتروني",
    "emailInvalid": "من فضلك ادخل بريد إلكتروني صحيح",
    "repeatPasswordError": "كلمة المرور غير متطابقة",
    "title2": "أكمل بيانات حسابك لتبدأ كتابة المقترحات",
    "firstName": "الإسم الأول",
    "lastName": "الإسم الأخير",
    "required": "مطلوب",
    "gender": "النوع",
    "whatsapp": "رقم هاتف واتساب",
    "code": "الكود",
    "phone": "رقم الهاتف",
    "city": "المدينة",
    "title3": " اختر مجال خبرتك، وسنعرض قصصك على الجهات الإعلامية المهتمة.",
    "formatsTitle": "الصيغ اللي تحب العمل عليها",
    "topicsTitle": "ما هي المواضيع التي تكتب عنها؟ (بحد أقصى 5)",
    "submitting": "جاري إنشاء الحساب",
    "complete": "أكمال التسجيل",
    "success": "تم إنشاء الحساب بنجاح!",
    "verify": "يرجى التحقق من بريدك الإلكتروني لتفعيل حسابك والبدء في تقديم مقترحاتك.",
    "minLength": "6 أحرف على الأقل",
    "upperCase": "حرف كبير واحد على الأقل",
    "number": "رقم واحد على الأقل",
    "special": "رمز خاص واحد على الأقل ('\"!@#$*;&:?-+)"
  },
  "login": {
    "title": "مرحبا بكم في ايجاب",
    "noAccount": "لا تمتلك حساب؟ ",
    "signup": "اشترك الآن",
    "error": "بيانات خاطئة! يرجى التحقق من البريد الإلكتروني/كلمة المرور",
    "email": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "repeatPassword": "إعادة كلمة المرور",
    "forget": "نسيت كلمة السر؟",
    "login": "تسجيل الدخول",
    "continue": "أو قم بتسجيل الدخول عبر",
    "google": "تسجيل دخول جوجل",
    "agreement": "بالنقر على \"تسجيل الدخول\"، فإنك توافق على ",
    "and": "و",
    "terms": "شروطنا وأحكامنا",
    "privacy": "سياسة الخصوصية"
  }
}
